<article class="signout-page">
  <div class="page-container">
    <div class="page-message-container">
      <div class="page-message">
        <img class="page-message-brand-link" src="assets/images/icons/kpmg-logo-blue.svg" alt="KPMG LOGO" />
        <h1 class="page-message-title">
          Logged Out!
        </h1>
        <p>
          You have been logged out
        </p>
        <button mat-flat-button color="primary" class="page-message-button" (click)="login()">
          Login
        </button>
      </div>
    </div>
  </div>
</article>
